import {
  UpdateState
} from "./actionTypes";



export const updateHistoryState = (state) => ({
  type: UpdateState,
  state
});